define('viewModels/privileged/base/BaseInstanceEditorSetup',[
    'lib/bluebird',
    'lib/knockout',
    'util/errorCallbackFactory',
    'viewModels/privileged/base/BaseTemplateEditorSetup',
    'viewModels/privileged/base/BaseInstanceEditor'
], function (Promise, ko, errorCallbackFactory, BaseTemplateEditorSetup, BaseInstanceEditor) {
    'use strict';

    var BaseInstanceEditorSetup = BaseTemplateEditorSetup.extend(function () {
        var self = this;

        /**
         * The viewmodel is ready to generate and editor.
         */
        self.ready = ko.observable(false);

        /**
         * Override
         */
        self.editorConstructor = BaseInstanceEditor;

        /**
         * If creating the instance from a template, this will be 'yes', otherwise we are crating from a schema and it
         * will be 'no'.
         */
        self.useTemplate = ko.observable('no');

        /**
         * A list of all the templates for this entity.
         */
        self.templateList = ko.observableArray();

        /**
         * The currently selected template.
         */
        self.selectedTemplate = ko.observable(null);

        /**
         * The loading state for the list of templates.
         */
        self.loadingTemplateList = ko.observable(true);

        /**
         *  The instance that will be updated.
         */
        self.instance = ko.observable(null);

        /**
         * The loading state for the instance.
         */
        self.loadingInstance = ko.observable(false);

        /**
         * Basically if this is switched off, a template reference will never be followed, and the entity will be
         * treated as if it was created directly from a schema.
         */
        self.canHaveTemplates = true;

        /**
         * Loads all of the templates for an entity.
         */
        self.loadTemplateList = function () {
            self.loadingTemplateList(true);
            return self.configService.listTemplates()
                .then(function (response) {
                    self.templateList(response.entities);
                    if (response.entities.length > 0) {
                        self.selectedTemplate(response.entities[0].selfUri);
                    }
                    return response;
                })
                .catch(errorCallbackFactory.createCallback({ namespace: 'config.error' }))
                .finally(function () {
                    self.loadingTemplateList(false);
                });
        };

        /**
         * Loads an entity instance for updating.
         */
        self.loadInstance = function (instanceUri) {
            self.isNew(false);
            self.loadingInstance(true);
            return self.configService.readInstance(instanceUri)
                .then(function (response) {
                    if (self.canHaveTemplates && response.template) {
                        self.useTemplate('yes');
                        self.selectedTemplate(response.template.selfUri);
                        self.instance(response);
                    }
                    else if (response.schema) {
                        self.useTemplate('no');
                        self.selectedSchema(response.schema.selfUri.toLowerCase());
                        self.instance(response);
                    }
                    self.name(response.name);
                    self.ready(true);
                    return response;
                })
                .catch(errorCallbackFactory.createCallback({ namespace: 'config.error' }))
                .finally(function () {
                    self.loadingInstance(false);
                });
        };

        /**
         * Override
         */
        self.editorView = self.computed(function () {
            var editor;

            if (self.ready()) {

                // Configure the editor to create a new instance from a template.
                if (self.isNew() && self.configEntityType() && self.useTemplate() === 'yes' && self.selectedTemplate()) {
                    editor = self.subView(self.editorConstructor);
                    editor.configure({
                        setup: self,
                        configEntityType: self.configEntityType(),
                        templateUri: self.selectedTemplate()
                    });
                    return editor;
                }

                // Configure the editor to create a new instance from a schema.
                else if (self.isNew() && self.configEntityType() && self.useTemplate() === 'no' && self.selectedSchema()) {
                    editor = self.subView(self.editorConstructor);
                    editor.configure({
                        setup: self,
                        configEntityType: self.configEntityType(),
                        schemaUri: self.selectedSchema()
                    });
                    return editor;
                }

                // Configure the editor to update an existing instance.
                else if (self.configEntityType() && self.instance()) {
                    editor = self.subView(self.editorConstructor);
                    editor.configure({
                        setup: self,
                        configEntityType: self.configEntityType(),
                        instanceUri: self.instance().selfUri
                    });
                    return editor;
                }
            }

            return null;
        });

        /**
         * Override
         */
        self.configure = function (options) {
            options = options ? options : {};
            self.isNew(true);
            self.ready(false);
            self.canHaveTemplates = options.hasTemplates;

            self.configEntityType(options.configEntityType);

            // Set the editor instance constructor.
            if (options.editorConstructor) {
                self.editorConstructor = options.editorConstructor;
            }

            // Load the complete list of schemas.
            var schemaDeferred = self.loadSchemaList();

            // Not every entity has templates.
            var templateDeferred;
            if (options.hasTemplates) {
                self.useTemplate('yes');

                // Load the complete list of templates.
                templateDeferred = self.loadTemplateList();
            }
            else {
                self.useTemplate('no');
            }

            // If a template URI is passed in then we are updating an existing template.
            Promise.all([schemaDeferred, templateDeferred]).then(function () {
                if (options.instanceUri) {
                    self.loadInstance(options.instanceUri);
                }
                else {
                    self.ready(true);
                }
            });
        };
    });

    return  BaseInstanceEditorSetup;
});

